<template>
    <div class="wrapper__wpd">
        <el-row class="footer__box">
            <el-col :span="4" v-for="(item, index) in footerList" :key="index" v-if="!item.footerHidden">
<!--                <div class="footer__level">{{item.name}}</div>-->
<!--                <div class="footer__send" v-if="item.child" v-for="(it, ind) in item.child" :key="ind">{{it.name}}</div>-->
                <router-link  class="footer__level" tag="div" :to="item.path" >{{item.name}}</router-link>
                <router-link  class="footer__send" tag="div" v-if="item.child" v-for="(it, ind) in item.child" :key="ind" :to="it.path" >{{it.name}}</router-link>
            </el-col>
            <el-col :span="4" class="atten__text">
                <div class="atten">关注我们</div>
                <div class="atten__ewm"><img :src="icon_ewm" ></div>
            </el-col>
        </el-row>
        <div class="footer__copy">
            <div class="fl">@Copyright 2020 YinShang all rights reserved.Powered by: JiTong Culture</div>
<!--            <div class="fl">浙ICP备2020038817号-1</div>-->
            <a class="fl" style="display: block;color: rgb(147, 147, 147);margin-right: 10px;text-decoration-line: none;" target="_blank" href="https://beian.miit.gov.cn/" >浙ICP备2020038817号-1</a>
            <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33010502004755" ><img src="@/assets/img/beian.png" style="float:left;"/><p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;">浙公网安备 33010502004755号</p></a>
        </div>

    </div>
</template>

<script>
    import icon_ewm from '@/assets/img/ewm.png'
    import {cateList} from '@/libs/router'
    export default {
        name: 'Footer',
        data (){
            return {
                icon_ewm,
                footerList: []
            }
        },
        components: {
        },
        computed: {
        },
        mounted() {
            this.footerList = cateList
        },
        methods: {
        }
    }
</script>

<style lang="scss" scoped>
    .footer__box{
        padding: 50px 0;
    }
    .footer__level, .atten{
        font-size: 16px;
        font-weight: 400;
        color: #000000;
        cursor: pointer;
    }
    .footer__send{
        cursor: pointer;
        font-size: 14px;
        font-weight: 400;
        color: #333;
        margin-top: 20px;
    }
    .footer__send:hover, .footer__level:hover{
        color: #F55E1B;
    }
    .footer__copy{
        padding-bottom: 50px;
        border-top: 1px solid #999;
        padding-top: 20px;
        font-size: 16px;
        color: rgb(147, 147, 147);
        & > div{
            margin-right: 20px;
        }
    }
    .atten__text {
        text-align: center;
        .atten__ewm {
            width: 188px;
            height: 188px;
            margin: 0 auto;
            margin-top: 5px;
            img {
                display: block;
                width: 100%;
                height: 100%;
            }
        }
    }
</style>
